<h1 mat-dialog-title class="aza-pa-dialog-title">
    <span translate>STARTING_PROCESS</span>
</h1>

<div mat-dialog-content class="aza-pa-dialog-content">
    <div class="aza-pa-flex-column">
        <span translate>DURING_THE_TIME_PERIOD_THIS_PROCESS_WAS_PAUSED_MESSAGES_HAVE_BEEN_SAVED</span>
        <azavista-input-field (valueChanged)="onPublishSavedMessagesFieldValueChanged($event)"
            [field]="fields.publishSavedMessages" [value]="fields.publishSavedMessagesValue"
            label="{{'PUBLISH_SAVED_MESSAGES' | translate}}" [showLabelForBooleans]="true" [editMode]="true"
            [canEdit]="true" [fullWidth]="true"></azavista-input-field>
    </div>
</div>

<div mat-dialog-actions class="aza-pa-dialog-actions">
    <azavista-button (click)="onCancel()" class="aza-pa-dialog-action-cancel-button"><span translate>CANCEL</span></azavista-button>
    <azavista-button (click)="onOk()" color="primary" class="aza-pa-dialog-action-apply-button"><span translate>OK</span>
    </azavista-button>
</div>
